/* eslint-disable */
<template>
  <div class="manage-case">
    <AdminNavigation ref="navigation" indexProps="1" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>{{ !singleCase.CaseID ? 'Create case' : 'Update case' }}</h1></div>
        <div class="header-sub-title">Cases help clients keep track of all the services required for a particular matter (claimant + event).</div>
      </div>
    </div>
    <div class="panel no-sub-menu">
      <div class="content">
        <div class="box">
          <div class="box-heading">
            <span>Case Details</span>
          </div>
          <div class="box-body">
            <div class="box-row" v-if="singleCase.CaseID">
              <div class="box-col box-col-left">Status</div>
              <div class="box-col box-col-right">
                <select v-model="singleCase.CaseStatus" class="textbox w-50">
                  <option v-for="status in statusList" :value="status.value">{{status.text}}</option>
                </select>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Client</div>
              <div class="box-col box-col-right">
                <div v-if="!singleCase.CaseID">
                  <select v-model="singleCase.ClientID" class="w-50 px-3" @change="loadClient()" :class="hasError && clientError ? 'is-invalid' : ''">
                    <option value="" hidden>Please choose client...</option>
                    <option v-for="(client, index) in clients" :key="index" :value="client.id">{{ client.name +' - '+ client.branchName }}</option>
                  </select>
                  <div class="text-danger" v-if="hasError && clientError">{{ clientError }}</div>
                </div>
                <div v-else>
                  <input type="text" disabled class="w-50 pl-3" :value="client.name + ' - ' + client.branchName" />
                </div>
                <router-link :to="{ path: '/admin-manage-client' }"
                  ><img src="@/assets/images/add_black_icon.svg" alt="" class="right-element align-self-center is-icon pr-3" style="top:50%;margin-top:-12px;"
                /></router-link>
              </div>
            </div>
            <!-- <div class="box-row"> //removed it from case
              <div class="box-col box-col-left">On behalf of</div>
              <div class="box-col box-col-right">
                <input type="text" class="textbox behalf" v-model="singleCase.onBehalfOf" placeholder="On behalf of" />
              </div>
            </div> -->
              <div class="box-row">
                <div class="box-col box-col-left">Examinee Name</div>
                <div class="box-col box-col-right" @click="openNameModal()">
                  <span class="px-3">{{ decodeURIComponent(singleCase.ClaimantFullName) }}</span>
                  <div class="text-danger" v-if="hasError && claimantNameErrors">{{ claimantNameErrors }}</div>
                </div>

              </div>
            <AddNameModal ref="addNameModal" @setName="setName" />

            <div class="box-row">
              <div class="box-col box-col-left">Examinee Salutation</div>
              <div class="box-col box-col-right" >
                <el-select class="w-50" v-model="singleCase.Salutation" filterable clearable placeholder="Select Salutation">
                  <el-option v-for="item in salutationList" :key="item.value" :value="item.value" :label="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Examinee Preferred Name</div>
              <div class="box-col box-col-right" >
                <input class="px-3 w-50" v-model="singleCase.PreferredGivenName" maxlength="100"
                       :class="hasError && preferredGivenNameError ? 'is-invalid' : ''" @blur="trimCaseField('PreferredGivenName')" />
                <div class="text-danger" v-if="hasError && preferredGivenNameError">{{ preferredGivenNameError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Date of Birth</div>
              <div class="box-col box-col-right">
                <datepicker
                  format="dd/MM/yyyy"
                  :typeable="true"
                  class="date-of-birth"
                  placeholder="dd/mm/yyyy"
                  v-model="singleCase.DateofBirth"
                  :input-class="'form-control px-3' + (hasError && dateOfBirthError ? ' is-invalid' : '')"
                  :disabled-dates="disabledDates"
                  @input="changeDateOfBirth"></datepicker>
                <div class="text-danger" v-if="hasError && dateOfBirthError">{{ dateOfBirthError }}</div>
              </div>
            </div>
            <!-- <div class="box-row">
              <div class="box-col box-col-left">Commencement Date</div>
              <div class="box-col box-col-right">
                <datepicker
                  format="dd/MM/yyyy"
                  :typeable="true"
                  input-class="form-control px-3"
                  :input-class="hasError && !validateCommencementDate ? 'is-invalid' : ''"
                  placeholder="dd/mm/yyyy"
                  v-model="singleCase.commencementDate"
                  :disabled-dates="disabledDates"></datepicker>
                <div class="text-danger" v-if="hasError && !validateCommencementDate">
                  Please enter Commencement Date
                </div>
              </div>
            </div> -->
            <div class="box-row">
              <div class="box-col box-col-left">Examinee Contact Details<br /></div>
              <div class="box-col box-col-right">
                <div @click="openManageContactModal" v-if="contactString == ''" class="parent">
                  <input type="text" class="child px-3" disabled placeholder="Please click here to enter contact details" />
                </div>
                <span class="pl-4" @click="openManageContactModal" v-else v-html="contactString"></span>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">
                Examinee Address
              </div>
              <div class="box-col box-col-right parent" @click="openManageAddressModal">
                <input class="child w-100 px-3" v-if="claimantAddress === ''" disabled placeholder="Please click here to update claimant's address" />
                <span class="px-3" v-else>{{ claimantAddress }}</span>
                <div class="text-danger px-3" v-if="hasError && claimantAddressErrors">{{ claimantAddressErrors }}</div>
              </div>
            </div>
            <!-- <div class="box-row pb-0"> //removed it from case
              <div class="box-col box-col-left mx-0">
                <label class="pb-0 mb-0">Date of Accident/Event</label>
              </div>
              <div class="box-col box-col-left mx-0">
                <datepicker
                  format="dd/MM/yyyy"
                  :typeable="true"
                  class="accient-date"
                  placeholder="dd/mm/yyyy"
                  v-model="singleCase.accidentDate"
                  :disabled-dates="disabledDates"
                  input-class="w-100 px-3"
                  :input-class="hasError && !isValidAccidentDate ? 'is-invalid' : ''"
                  :disabled="overTime ? true : false"
                  @input="changeAccientDate" />
                <div class="text-danger" v-if="hasError && !isValidAccidentDate">
                  Date of Accident/Event is invalid
                </div>
              </div>
              <div class="box-col box-col-left mx-0 d-flex align-items-center">
                <input type="checkbox" v-model="overTime" :sync="true" class="d-inline-block mr-3" id="overTime" @change="changeOverTime" />
                <label for="overTime" style="margin-bottom: 0px;"> Over a period of time</label>
              </div>
              <div class="box-col box-col-left mx-0">
                &nbsp;
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Affected Body Areas</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input
                  class="px-3 pr-7"
                  v-model="bodyArea"
                  :tags="bodyAreas"
                  @focus="openDigram()"
                  :validation="validate"
                  placeholder="Please choose"
                  @before-deleting-tag="deleteBodyArea"
                />
                <div @click="openBodyDiagram">
                  <img src="@/assets/images/choose.svg" alt="" class="right-element align-self-center is-icon pr-3" style="top:50%;margin-top:-18px;"/>
                </div>
                <AddBodyDiagramModal style="top: 0px" ref="addBodyDiagramModal" />
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Other Body Areas</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input
                  class="px-3"
                  v-model="otherBodyAreaTag"
                  :tags="otherBodyAreaTags"
                  placeholder="Add Other Body Areas"
                  @tags-changed="(newTags) => (otherBodyAreaTags = newTags)" />
              </div>
            </div>
            <div class="box-row reset-line-height">
              <div class="box-col box-col-left">Conditions</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input
                  ref="conditions"
                  class="px-3 conditions"
                  v-model="condition"
                  :tags="conditions"
                  :add-only-from-autocomplete="true"
                  :autocomplete-items="filteredConditions"
                  @tags-changed="updateConditions"
                  :validation="validate"
                  placeholder="Add Conditions"
                  @before-deleting-tag="deletePersonCondition"
                />
              </div>
            </div> -->
          </div>
        </div>
        <div class="alert alert-success hidden-element">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
        </div>
        <div class="alert alert-danger hidden-element">
          <a class="close" title="close">×</a>
          <b>Error:</b> {{ errorMessage }}
        </div>
        <div class="right-element"><v-btn dark @click="submit">{{ !this.singleCase.CaseID ? 'Create' : 'Update' }}</v-btn></div>
       <br>
       <br>
        <div class="header-title ml-0 mt-10" style="padding-left=0px" v-if="isEdit">File Summary</div>
        <div class="" v-if="isEdit">
          <div class="table-responsive position-relative">
            <div class="move-files">
              <div class="move-files-content">
                <div class="move-files-button"><v-btn dark @click="moveFiles">Move To</v-btn></div>
                <div class="case-bookings ml-1">
                  <select v-model="moveToBookingId" class="textbox">
                    <option value='0'>Select</option>
                    <option v-for="booking in bookings" :value="booking.BookingID">{{ booking.BookingID }}</option>
                  </select>
                </div>
              </div>
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th class="hidden-element">Id</th>
                  <th style="width:5%"></th>
                  <th style="width:20%" class="long-text">File Type</th>
                  <th style="width:30%" class="long-text">File Name</th>
                  <th style="width:10%" class="long-text">Booking ID</th>
                  <th style="width:15%" class="long-text">Uploaded by</th>
                  <th style="width:10%" class="long-text">Status</th>
                  <th style="width:5%" class="long-text"></th>
                  <th style="width:5%" class="long-text"></th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="table-responsive" style="max-height: 200px">
            <table class="table" :key="fileKey">
              <tbody>
                <tr v-for="(file, index) in allBookingFiles" v-if="allBookingFiles.length > 0">
                  <td style="width:5%"><input type="checkbox" class="form-checkbox" :value="index" @change="changeCheckbox($event)" /></td>
                  <td style="width:20%" class="long-text">{{file.FileType.FileTypeName}}</td>
                  <td style="width:30%" class="long-text">{{decodeURIComponent(file.FileName)}}</td>
                  <td style="width:10%" class="long-text">{{file.BookingID}}</td>
                  <td style="width:15%" class="long-text">{{decodeURIComponent(file.UploadedUser.UserName)}}</td>
                  <td style="width:10%" class="long-text">{{file.FileStatus == 2 ? 'Complete' : getFileStatusNameById(file.FileStatus)}}</td>
                  <td style="width:5%" @click="deleteFile(file.BookingFileID, index, file.UploadedBy)" class="long-text"><img src="@/assets/images/delete_icon.svg" /></td>
                  <td style="width:5%" class="long-text"><div @click="getFileUrl(file)"><img src="@/assets/images/eye-icon.svg" /></div></td>
                </tr>
                <tr v-if="allBookingFiles.length == 0">
                  <td>No Files</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="this.singleCase.CaseID" class="box mt-20" style="margin-top: 100px;">
          <div class="box-heading col-space-between">
            <div>Bookings : {{bookings.length}}</div>
            <div>
              <router-link :to="{ name: 'admin-search-specialist', query: { id: this.singleCase.CaseID }}" class="router-link"><v-btn class="add-icon submit-request" dark>Add New</v-btn></router-link>
            </div>
          </div>
          <div v-if="this.singleCase.CaseID" class="box-body" style="max-height: 250px;overflow: hidden;overflow-y: auto;">
            <div v-if="bookings.length > 0" >
              <div class="box-row d-flex align-items-center" v-for="(booking, index) in bookings" :key="index">
                <div class="list-detail-row is-icon">
                  <div class="box-col" style="width: 90%;">
                    ID: {{booking.BookingID}} {{booking.BookingType.BookingTypeName + ","}} {{formatDate(booking.BookingDateTime, "hh:mm A DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss.ssssss")}} {{getSpecialistFullNameUpper(booking.Specialist)}} {{booking.clientName}} {{booking.branchName}}
                  </div>
                  <div class="box-col" style="width: 15%;text-align: end;">
                    {{getBookingStatusById(booking.BookingStatus)}}
                  </div>
                </div>
                <el-button class="mr-5" style="background: #525252; color: white; border-radius: 4px" typs="primary" size="small" @click="editBooking(booking)">View</el-button>
              </div>
            </div>
            <div v-else class="box-row" style="padding: 10px;">
              No bookings
            </div>
          </div>
        </div>
      </div>
    </div>
    <BookingModal @closeModal="booking = null" :booking="booking" />
    <AdminCaseCreatedModal ref="adminCaseCreatedModal" :clientProps="false" />
    <AdminManageContactModal ref="adminManageContactModal" />
    <AdminManageClaimantAddressModal :passedCasesProps="singleCase" ref="adminManageAddressModal" />
    <AddClientContactModal ref="addClientContactModal" typrProps="fromcases" />
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import AdminNavigation from '@/components/AdminNavigation'
  import Header from '@/components/Header'
  import AdminCaseCreatedModal from '@/components/AdminCaseCreatedModal'
  import AdminManageContactModal from '@/components/AdminManageContactModal'
  import AdminManageClaimantAddressModal from '@/components/AdminManageClaimantAddressModal'
  import AddClientContactModal from '@/components/AddClientContactModal'
  import AddNameModal from '@/components/AddNameModal'
  import BookingModal from '@/components/case/BookingModal'
  // import AddBodyDiagramModal from '@/components/AddBodyDiagramModal'

  export default {
    name: 'AdminManageCase',
    components: {
      AdminNavigation,
      BookingModal,
      Header,
      AdminCaseCreatedModal,
      AdminManageContactModal,
      AdminManageClaimantAddressModal,
      AddClientContactModal,
      AddNameModal,
      // AddBodyDiagramModal,
    },
    data() {
      return {
        hasError: false,
        successMessage: '',
        errorMessage: '',
        salutationList: utilities.initSalutation(),
        // Validate Dates
        isValidDateOfBirth: true,
        isValidAccidentDate: true,

        clientFocus: false,
        contactFocus: false,
        claimFocus: false,

        overTime: false,

        focused: '',
        client: utilities.initClient(),
        singleCase: utilities.initCase(),
        bookingStatuses: utilities.getBookingStatuses(),
        statusList: utilities.getStatus(),
        booking: null,
        clients: [],
        claimTypes: [],
        bookings: [],
        fileStatus: utilities.getFileStatus(),
        allBookingFiles: [],
        selectedBookings: [],
        moveToBookingId: 0,
        isEdit: false,
        fileKey: 0,
        disabledDates: {
          from: moment().toDate(),
        },

        validate: [
          {
            classes: 'test',
            rule: (tag) => tag.length > 0,
          },
        ],

        loaded: false,
      }
    },
    watch: {
      singleCase: {
        handler(value) {
          if (this.loaded) this.$store.dispatch('setNewObject', value)
        },
        deep: true,
      },
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
      clientError() {
        if (this.singleCase.CaseID) return ''
        const id = this.singleCase.ClientID
        if (id === '' || id === null || id === undefined) return 'Please select a client.'
        return ''
      },
      firstNameError() {
        return utilities.getClientContactPersonNameError(this.singleCase.ClaimantFirstName, 'First name')
      },
      middleNameError() {
        return utilities.getClientContactMiddleNameError(this.singleCase.ClaimantGivenNames)
      },
      surnameError() {
        return utilities.getClientContactPersonNameError(this.singleCase.ClaimantSurname, 'Surname')
      },
      claimantNameErrors() {
        return [this.firstNameError, this.middleNameError, this.surnameError].filter(Boolean).join(' ')
      },
      preferredGivenNameError() {
        return utilities.getClientContactMiddleNameError(this.singleCase.PreferredGivenName)
      },
      dateOfBirthError() {
        if (this.singleCase.DateofBirth === '' || this.singleCase.DateofBirth === null || this.singleCase.DateofBirth === undefined) {
          return ''
        }
        const inputVal = $(".date-of-birth input").val()
        if (inputVal && moment(inputVal, 'DD/MM/YYYY', true).isValid()) {
          return ''
        }
        if (this.singleCase.DateofBirth instanceof Date && !isNaN(this.singleCase.DateofBirth.getTime())) {
          return ''
        }
        if (moment(this.singleCase.DateofBirth).isValid()) {
          return ''
        }
        return 'Enter a valid date of birth (dd/mm/yyyy).'
      },
      claimantMobileError() {
        const n = utilities.normalizeAuPhoneInput(this.singleCase.ClaimantMobile)
        if (!n) return ''
        return utilities.getClientContactPhoneAu12Error(n, 'Mobile')
      },
      claimantEmailError() {
        return utilities.getClientContactEmailError(this.singleCase.ClaimantEmail, 'Email address', false)
      },
      claimantLandLineError() {
        const n = utilities.normalizeAuPhoneInput(this.singleCase.ClaimantPhone1)
        if (!n) return ''
        return utilities.getClientContactPhoneAu12Error(n, 'Land line')
      },
      claimantWorkPhoneError() {
        const n = utilities.normalizeAuPhoneInput(this.singleCase.ClaimantPhone2)
        if (!n) return ''
        return utilities.validateLandPhone(n)
      },

      claimantAddressLine1Error() {
        const s = String(this.singleCase.ClaimantAddressLine1 === undefined || this.singleCase.ClaimantAddressLine1 === null ? '' : this.singleCase.ClaimantAddressLine1).trim()
        if (!s) return ''
        if (s.length > 100) return 'Address line 1 must not exceed 100 characters.'
        const e = utilities.getValidateAddressError(s)
        return e === null ? '' : e
      },
      claimantAddressLine2Error() {
        const s = String(this.singleCase.ClaimantAddressLine2 === undefined || this.singleCase.ClaimantAddressLine2 === null ? '' : this.singleCase.ClaimantAddressLine2).trim()
        if (!s) return ''
        if (s.length > 100) return 'Address line 2 must not exceed 100 characters.'
        const e = utilities.getValidateAddressError(s)
        return e === null ? '' : e
      },
      claimantCityError() {
        const s = String(this.singleCase.ClaimantCity === undefined || this.singleCase.ClaimantCity === null ? '' : this.singleCase.ClaimantCity).trim()
        if (!s) return ''
        const e = utilities.getValidateCityError(s)
        if (e !== null) return e
        if (s.length > 20) return 'City must not exceed 20 characters.'
        return ''
      },
      claimantStateError() {
        const s = this.singleCase.ClaimantState
        if (s === undefined || s === null || String(s).trim() === '') return ''
        return ''
      },
      claimantPostcodeError() {
        const raw = this.singleCase.ClaimantPostcode
        const s = raw === undefined || raw === null ? '' : String(raw).trim()
        if (!s) return ''
        const e = utilities.getValidatePostCodeError(s)
        return e === null ? '' : e
      },
      claimantAddressErrors() {
        return [
          this.claimantAddressLine1Error,
          this.claimantAddressLine2Error,
          this.claimantCityError,
          this.claimantStateError,
          this.claimantPostcodeError,
        ].filter(Boolean).join(' ')
      },
      clientAddress() {
        var address = ''
        if (this.client.AddressLine1 != '') address += this.client.AddressLine1 + ', '
        if (this.client.AddressLine2 != '') address += this.client.AddressLine2 + ', '
        if (this.client.city != '') address += this.client.city + ', '
        if (this.client.state != '') address += this.client.state + ' '
        if (this.client.postcode != '') address += this.client.postcode
        return address
      },
      claimantAddress() {
        var address = ''
        if (this.singleCase.ClaimantAddressLine1) address += this.singleCase.ClaimantAddressLine1 + ', '
        if (this.singleCase.ClaimantAddressLine2) address += this.singleCase.ClaimantAddressLine2 + ', '
        if (this.singleCase.ClaimantCity) address += this.singleCase.ClaimantCity + ', '
        if (this.singleCase.ClaimantState) address += this.singleCase.ClaimantState + ' '
        if (this.singleCase.ClaimantPostcode) address += this.singleCase.ClaimantPostcode
        return address
      },
      filteredBodyAreas() {
        return this.bodyAreasAutocomplete.filter((i) => {
          return i.text.toLowerCase().indexOf(this.bodyArea.toLowerCase()) !== -1
        })
      },
      filteredConditions() {
        return this.conditionsAutocomplete.filter((i) => {
          return i.text.toLowerCase().indexOf(this.condition.toLowerCase()) !== -1
        })
      },
      contactString() {
        var phone = !this.singleCase.ClaimantPhone1 ? '' : '<strong>Phone: </strong>' + this.singleCase.ClaimantPhone1
        var mobile = !this.singleCase.ClaimantMobile ? '' : '<strong ' + (phone == '' ? '' : 'class="ml-3"') + '>Mobile: </strong>' + decodeURIComponent(this.singleCase.ClaimantMobile)
        var work = !this.singleCase.ClaimantPhone2 ? '' : '<strong ' + (phone == '' && mobile == '' ? '' : 'class="ml-3"') + '>Work: </strong>' + decodeURIComponent(this.singleCase.ClaimantPhone2)
        var email = !this.singleCase.ClaimantEmail ? '' : '<strong ' + (phone == '' && mobile == '' && work == '' ? '' : 'class="ml-3"') + '>Email: </strong>' + decodeURIComponent(this.singleCase.ClaimantEmail)
        return phone + mobile + work + email

        // <strong>Phone: </strong>12345<strong class="ml-3">Mobile: </strong>0453 123 123<strong class="ml-3">Work: </strong>0343 456 456<strong class="ml-3">Email: </strong>jsmith@theworld.com.au
      },
    },
    methods: {

      validateDateOfBirth() {
        if (this.singleCase.DateofBirth === '' || this.singleCase.DateofBirth === null || this.singleCase.DateofBirth === undefined) {
          return true
        }
        return !this.dateOfBirthError
      },

      validateAllDates() {
        return !this.dateOfBirthError
      },

      sanitizeCaseBeforeSubmit() {
        this.singleCase.ClaimantFirstName = String(this.singleCase.ClaimantFirstName || '').trim()
        this.singleCase.ClaimantGivenNames = String(this.singleCase.ClaimantGivenNames || '').trim()
        this.singleCase.ClaimantSurname = String(this.singleCase.ClaimantSurname || '').trim()
        this.singleCase.PreferredGivenName = String(this.singleCase.PreferredGivenName || '').trim()
        this.singleCase.ClaimantEmail = String(this.singleCase.ClaimantEmail || '').trim()
        this.singleCase.ClaimantMobile = utilities.normalizeAuPhoneInput(this.singleCase.ClaimantMobile)
        this.singleCase.ClaimantPhone1 = utilities.normalizeAuPhoneInput(this.singleCase.ClaimantPhone1)
        this.singleCase.ClaimantPhone2 = utilities.normalizeAuPhoneInput(this.singleCase.ClaimantPhone2)
        this.singleCase.ClaimantAddressLine1 = String(this.singleCase.ClaimantAddressLine1 || '').trim()
        this.singleCase.ClaimantAddressLine2 = String(this.singleCase.ClaimantAddressLine2 || '').trim()
        this.singleCase.ClaimantCity = String(this.singleCase.ClaimantCity || '').trim()
        if (this.singleCase.ClaimantState != null && this.singleCase.ClaimantState !== '') {
          this.singleCase.ClaimantState = String(this.singleCase.ClaimantState).trim()
        }
        this.singleCase.ClaimantPostcode = this.singleCase.ClaimantPostcode != null && this.singleCase.ClaimantPostcode !== ''
          ? String(this.singleCase.ClaimantPostcode).trim()
          : ''
        this.singleCase.ClaimantFullName = utilities.getClaimantFullNameUpper(this.singleCase)
      },

      trimCaseField(prop) {
        const v = this.singleCase[prop]
        if (v === undefined || v === null) return
        this.singleCase[prop] = String(v).trim()
      },

      changeCheckbox(e) {
        var index = Number($(e.target).val())
        if(index > -1) {
          var booking = this.allBookingFiles[index]
          if (e.target.checked) {
            // Add to list
            this.selectedBookings.push(booking)
          } else {
            // Remove from list
            this.selectedBookings = this.selectedBookings.filter(x => x.bookingFileId != booking.bookingFileId)
          }
          // console.log(this.selectedBookings.map(x => { return { bookingFileId: x.bookingFileId, bookingId: x.bookingId } }))

          var checkedNumber = $('.form-checkbox:checked').length
          if (checkedNumber > 0) {
            $('.move-files').show()
          } else {
            $('.move-files').hide()
          }
        }
      },

      changeDateOfBirth() {
        setTimeout(() => {
          this.isValidDateOfBirth = !this.dateOfBirthError
        }, 200)
      },

      // changeAccientDate() { //removed it from case
      //   setTimeout(() => {
      //     this.isValidAccidentDate = this.validateAccidentDate()
      //   }, 200)
      // },
      // changeOverTime() { //removed it from case
      //   if(this.overTime) this.singleCase.accidentDate = ''
      //   this.isValidAccidentDate = this.validateAccidentDate()
      // },

      editBooking(item) {
        this.booking = item
      },

      // openBodyDiagram() { //removed it from case
      //   this.$refs.addBodyDiagramModal.handleModal()
      //   this.$refs.addBodyDiagramModal.filteredBodyAreas = this.bodyAreasAutocomplete
      //   this.$refs.addBodyDiagramModal.bodyAreas = _.cloneDeep(this.bodyAreas)
      //   this.$refs.addBodyDiagramModal.isFromAdmin = true
      //   this.$refs.addBodyDiagramModal.handleClick()
      // },

      getFileStatusNameById(id) {
        if(id == 2) {
          return 'Complete'
        } else if (id == 3) {
          return 'For Review'
        }
        if (id == 0 || id == 1) {
          return this.fileStatus.find((x) => x.id == id).name
        }
        return ''
      },

      async moveFiles() {
        if(this.selectedBookings.length > 0 && this.moveToBookingId != 0) {
          await this.$store.dispatch('loading/setLoadComponent', true)
          var result = await this.postMoveBookingFiles()
          if (result) {
            this.allBookingFiles.filter(x => this.selectedBookings.map(y => { return y.BookingFileID }).includes(x.BookingFileID)).map(x => {
              x.bookingId = this.moveToBookingId
            })
            this.selectedBookings = []
            await this.loadData()
            $('.form-checkbox').prop("checked", false)
            $('.move-files').hide()
            utilities.showSuccessMessage("The files have been moved to Booking ID " + this.moveToBookingId)
          }
          await this.$store.dispatch('loading/setLoadComponent', false)
        }
      },

      async postMoveBookingFiles() {
        var params = {
          UserID: this.user.id,
          Username: this.user.name,

          FilesToMove: [],
          DestinationBookingID: this.moveToBookingId,
        }

        var allBookingFiles = this.allBookingFiles.filter(x => this.selectedBookings.map(y => { return y.BookingFileID }).includes(x.BookingFileID))
        allBookingFiles.map(x => {
          if(x.bookingId != this.moveToBookingId) {
            params.FilesToMove.push({
              FileName: x.fileName,
              BID: x.bookingId,
            })
          }
        })

        if(params.FilesToMove.length == 0) return false

        return await utilities.postMoveBookingFiles(params)
      },

      async deleteFile(fileId, index, uploadedBy) {
        var file = this.allBookingFiles[index]
        await this.$confirm({
          content: 'Are you sure you want to delete this file?',
          onConfirm: async () => {
            await this.$store.dispatch('loading/setLoadComponent', true)
            var booking = this.bookings.find((x) => x.BookingID == file.BookingID)
            var params = {
              userId: this.user.id,
              userName: this.user.name,
              id: fileId,
            }

            var result = await utilities.deleteBookingFileById(params)
            if (result) {
              this.allBookingFiles.splice(index, 1)
            }
            this.$store.dispatch('loading/setLoadComponent', false)
          }
        })
      },

      getFileUrl(file) {
        if(!file.fileName) return
        const params = {
          uploadtype: "bf",
          fn: file.fileName,
          id: file.bookingId
        }
        utilities.getFileUrlNew(params).then(res => {
          let a = document.createElement('a');
          let fileName = file.fileName
          a.target = '_blank'
          a.download = fileName;
          a.href = res
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(res);
          document.body.removeChild(a);
        })
      },

      async setImageUrl() {
        var temp = this.allBookingFiles
          await Promise.all(temp.map(async(x) =>{
          if (x.fileName != '') {
            var params = {
              uploadtype: "bf",
              fn: x.fileName,
              id: x.bookingId
            }
            x.fileUrl = await utilities.getFileUrlNew(params)
          }
        }))
        this.allBookingFiles = temp
        setTimeout(() =>{
          this.fileKey += 1
        }, 500)
      },

      async loadData() {
        await this.$store.dispatch('loading/setLoadComponent', true)
        this.singleCase.CaseID = this.$route.query.id !== undefined ? this.$route.query.id : ''
        if (this.singleCase.CaseID !== '') {

          const caseData = await utilities.getCaseByCaseId(this.singleCase.CaseID)
          console.log(caseData)
          Object.keys(caseData).forEach(item => {
            console.log(typeof caseData[item])
            if(typeof caseData[item] === 'string') {
              caseData[item] = decodeURIComponent(caseData[item])
            }
          })
          this.singleCase = caseData

          this.client = await utilities.getClientById(this.singleCase.ClientID)

          // this.booking.bodyAreas.map((x) => { //removed it from case
          //   this.bodyAreas.push({ id: x.caseBodyAreaId, text: x.bodyArea, caseId: this.$route.query.id })
          // })
          // this.booking.personCondition.map((x) => {
          //   this.conditions.push({ id: x.id, text: x.name, caseId: this.$route.query.id })
          // })
          // this.overTime = this.singleCase.overPeriodofTime
        } else {
          this.clients = await utilities.getClients()
          this.clients = this.clients.sort((a,b) => {
            return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1
          })
        }

        if (this.$route.query.clientId != undefined) {
          this.clientFocus = true
          this.singleCase.ClientID =  this.$route.query.clientId != undefined ? this.$route.query.clientId : ''
          this.loadClient()
        }
        // this.bodyAreasAutocomplete = await utilities.getBodyArea() //Removed it from case
        // this.bodyAreasAutocomplete = this.bodyAreasAutocomplete.map((x) => {
        //   return { id: x.id, text: x.bodyArea }
        // })
        // this.conditionsAutocomplete = await utilities.getPersonConditions()
        // this.conditionsAutocomplete = this.conditionsAutocomplete.map((x) => {
        //   return { id: x.id, text: x.name }
        // })
        // if (this.singleCase.bodyAreaOther != '' && this.singleCase.bodyAreaOther.length > 0) {
        //   var items = this.singleCase.bodyAreaOther.split(',');
        //   this.otherBodyAreaTags = utilities.getAutoCompleteOtherBodyAreaTags(items)
        // }
        if (this.singleCase.CaseID) {
          this.isEdit = true
          this.getAllBookingFiles()

        }
        this.claimTypes = await utilities.getClaimTypes()
        await this.$store.dispatch('setOriginalObject', this.singleCase)
        await this.$store.dispatch('setNewObject', this.singleCase)
        await this.$store.dispatch('loading/setLoadComponent', false)
      },

      async getAllBookingFiles() {
        this.allBookingFiles = []
        this.bookings = this.singleCase.Bookings
        this.bookings.forEach((booking, i) => {
          if (booking.BookingFiles.length > 0) {
            booking.BookingFiles.forEach((file, i) => {
              file.bookingId = booking.BookingID
              this.allBookingFiles.push(file)
            });
          }
        });
      },

      getSpecialistFullNameUpper(specialist) {
        return utilities.getSpecialistFullNameUpper(specialist)
      },

      openManageAddressModal(e) {
        e.preventDefault()
        e.stopPropagation()
        this.$refs.adminManageAddressModal.loaded = false
        this.$refs.adminManageAddressModal.handleModal()
      },

      setBodyArea(bodyAreas) {
        this.bodyAreas = []
        this.bodyAreas = bodyAreas
      },

      async loadClient() {
        await this.$store.dispatch('loading/setLoadComponent', true)
        this.client = await utilities.getClientById(this.singleCase.ClientID)
        this.client.contacts.sort((a, b) => {
          return a.fullName > b.fullName ? 1 : -1
        })
        await this.$store.dispatch('loading/setLoadComponent', false)
      },

      getFormattedDate(dateToFormat) {
        var date = new moment(dateToFormat, 'YYYY-MM-DD')
        return date.format('DD/MM/YYYY')
      },

      getTravelStatusById(id) {
        if (this.travelStatuses.length > 0 && this.travel.specialist != undefined) {
          var status = this.travelStatuses.find((x) => x.id === id)
          return status.name
        }
      },
      openSearchModal(e) {
        e.preventDefault()
        e.stopPropagation()
      },
      openAdminCaseCreatedModal() {
        this.$refs.adminCaseCreatedModal.clientName = this.client != undefined ? this.client.name : '',
        this.$refs.adminCaseCreatedModal.caseId = this.singleCase.CaseID
        this.$refs.adminCaseCreatedModal.clientId = this.singleCase.ClientID
        this.$refs.adminCaseCreatedModal.handleModal()
      },

      async submit(e) {
        e.preventDefault()
        e.stopPropagation()

        this.sanitizeCaseBeforeSubmit()
        if (
          this.clientError ||
          this.firstNameError ||
          this.middleNameError ||
          this.surnameError ||
          this.preferredGivenNameError ||
          this.dateOfBirthError ||
          this.claimantAddressLine1Error ||
          this.claimantAddressLine2Error ||
          this.claimantCityError ||
          this.claimantStateError ||
          this.claimantPostcodeError
        ) {
          this.hasError = true
          utilities.showAlert('.alert-danger')
          return
        }
        this.hasError = false

        this.$store.dispatch('loading/setLoadComponent', true)

        var localCase = {
          ClientID: this.singleCase.ClientID,
          ClaimantFirstName: this.singleCase.ClaimantFirstName.trim(), //not mandatory
          ClaimantGivenNames: this.singleCase.ClaimantGivenNames, //not mandatory
          PreferredGivenName: this.singleCase.PreferredGivenName.trim(), //not mandatory
          Salutation: this.singleCase.Salutation,
          ClaimantSurname: this.singleCase.ClaimantSurname.trim(),
          ClaimantFullName: utilities.getClaimantFullNameUpper(this.singleCase),
          DateofBirth: moment(this.singleCase.DateofBirth).format("YYYY-MM-DD"),
          CaseStatus: this.singleCase.CaseStatus || '1',
        }

        localCase.ClaimantPhone1 = this.singleCase.ClaimantPhone1 || ""
        localCase.ClaimantPhone2 = this.singleCase.ClaimantPhone2 || ""
        localCase.ClaimantMobile = this.singleCase.ClaimantMobile || ""
        localCase.ClaimantEmail = this.singleCase.ClaimantEmail || ""
        localCase.ClaimantAddressLine1 = this.singleCase.ClaimantAddressLine1 || ""
        localCase.ClaimantAddressLine2 = this.singleCase.ClaimantAddressLine2 || ""
        localCase.ClaimantCity = this.singleCase.ClaimantCity
        localCase.ClaimantState = this.singleCase.ClaimantState
        localCase.ClaimantPostcode = this.singleCase.ClaimantPostcode
        localCase.ClaimantCountry = 'AU'


        if (this.singleCase.CaseID == '' || this.singleCase.CaseID == undefined) {


          var callback = (response) => {
            this.singleCase.CaseID = response
            //utilities.clearChangingObject()
            if(location.search.includes('clientId')) window.history.replaceState({}, document.title, location.pathname + "?id=" + this.singleCase.CaseID)
            // Trigger modal
            this.openAdminCaseCreatedModal()
            setTimeout(() =>{
              utilities.clearChangingObject()
            }, 500)

          }

          let obj = {...localCase}
          for (let key in obj) {
            if (obj[key] === null || obj[key] === '') {
              delete obj[key];
            }
          }

          await utilities.postCase(obj, callback)

          // if (this.singleCase.CaseID !== undefined) {
          //
          // }
          this.$store.dispatch('loading/setLoadComponent', false)
        } else {
          var callback = (response) => {
            if (this.singleCase.CaseID !== undefined && response) {
              utilities.clearChangingObject()
              this.successMessage = 'case Updated Successfully.'
              utilities.showAlert('.alert-success')
            }
            this.$store.dispatch('loading/setLoadComponent', false)
          }
          localCase.ZohoClaimantID = this.singleCase.zohoClaimantId
          let obj = {...localCase}
          for (let key in obj) {
            if (obj[key] === null) {
              delete obj[key];
            }
          }
          await utilities.putCase(this.singleCase.CaseID, obj, callback)
        }
      },
      formatDate(date, format = "YYYY-MM-DD", currentFormat = "YYYY-MM-DD") {
        if (date) {
          return utilities.formatDate(date, format, currentFormat)
        }
        return ""
      },
      getBookingStatusById(id) {
        if (id) {
          var status = this.bookingStatuses.find((x) => x.id == id)
          if (status) {
            return status.name
          }
        }
        return ""
      },

      openManageContactModal(e) {
        e.preventDefault()
        e.stopPropagation()
        this.$refs.addClientContactModal.singleCase = this.singleCase
        this.$refs.addClientContactModal.booking = this.booking
        this.$refs.addClientContactModal.setCaseContactDetails()
        this.$refs.addClientContactModal.handleModal()
      },

      /*  removed it from case*/
      // openDigram() {
      //   this.openBodyDiagram()
      // },
      //
      // async deleteBodyAreaItems(items) {
      //   items.map((x) => {
      //     this.deleteBodyArea(x)
      //   })
      //
      // },

      // async deleteBodyArea(e) {
      //   // Filter from list
      //   if (e.tag.caseId !== undefined) {
      //     // Delete
      //     this.singleCase.bodyAreas = this.singleCase.bodyAreas.filter((x) => x.caseBodyAreaId !== e.tag.id)
      //     // Call delete API
      //     this.$store.dispatch('loading/setLoadComponent', true)
      //     var params = {
      //       CaseID: this.singleCase.CaseID,
      //       BodyAreaObject: [{ CaseBodyAreaID: e.tag.id }],
      //       ClientID: this.singleCase.ClientID,
      //       ClaimTypeID: this.singleCase.claimTypeId,
      //       ClaimTypeName: this.claimTypes.find((x) => x.id == this.singleCase.claimTypeId).name,
      //       CaseOwner: this.singleCase.caseOwner,
      //       CaseReference: this.singleCase.caseReference,
      //       UserID: this.user.id,
      //       Username: this.user.name,
      //     }
      //     await utilities.deleteFromCase(params)
      //     this.$store.dispatch('loading/setLoadComponent', false)
      //   }
      //   this.bodyAreas.splice(e.index, 1);
      //   e.deleteTag()
      // },

      // async deletePersonCondition(e) {
      //   // Filter from list
      //   if (e.tag.caseId !== undefined) {
      //     // Delete
      //     this.singleCase.personCondition = this.singleCase.personCondition.filter((x) => x.caseBodyAreaId !== e.tag.id)
      //     // Call delete API
      //     this.$store.dispatch('loading/setLoadComponent', true)
      //     var params = {
      //       CaseID: this.singleCase.CaseID,
      //       ConditionObject: [{ CasePersonConditionID: e.tag.id }],
      //       ClientID: this.singleCase.ClientID,
      //       ClaimTypeID: this.singleCase.claimTypeId,
      //       ClaimTypeName: this.claimTypes.find((x) => x.id == this.singleCase.claimTypeId).name,
      //       CaseOwner: this.singleCase.caseOwner,
      //       CaseReference: this.singleCase.caseReference,
      //       UserID: this.user.id,
      //       Username: this.user.name,
      //     }
      //     await utilities.deleteFromCase(params)
      //     this.$store.dispatch('loading/setLoadComponent', false)
      //   }
      //   e.deleteTag()
      // },

      openNameModal() {
        if (this.singleCase.CaseID != '') {
          this.$refs.addNameModal.editFullName(this.singleCase.ClaimantFirstName, this.singleCase.ClaimantGivenNames, this.singleCase.ClaimantSurname)
        }
        this.$refs.addNameModal.handleModal()
      },

      setName(nameObject) {
        this.singleCase.ClaimantFirstName = nameObject.firstName ? nameObject.firstName.trim() : ''
        this.singleCase.ClaimantGivenNames = nameObject.middleName ? nameObject.middleName.trim() : ''
        this.singleCase.ClaimantSurname = nameObject.surname ? nameObject.surname.trim() : ''
        this.singleCase.ClaimantFullName = utilities.getClaimantFullNameUpper(this.singleCase)
      },
    },
    async beforeMount() {
      this.$store.dispatch('loading/setLoadComponent', true)
      $('body>.tooltip').remove()
      await this.loadData()
      this.loaded = true
      this.isValidDateOfBirth = this.validateDateOfBirth()
      //this.isValidAccidentDate = this.validateAccidentDate()
      this.$store.dispatch('loading/setLoadComponent', false)

      if(this.bookings.length > 0) this.moveToBookingId = this.bookings[0].BookingID

      $('.behalf').keydown((e) => {
          var code = e.keyCode || e.which;
          if (code === 9) {
            this.openNameModal()
          }
      });

      $('.date-of-birth').keydown((e) => {
          var code = e.keyCode || e.which;
          if (code === 9) {
            this.openManageContactModal(e)
          }
      });

      $('.conditions').keydown((e) => {
          var code = e.keyCode || e.which;
          if (code === 9) {
            this.claimFocus = true
          }
      });
      $(document).ready(function() {
          $(".claim").click(function() {
             $("#sel").simulate('mousedown');
          });
      });
    },
    mounted() {},
  }
</script>
